import { incomeTypes, Personality } from "../constants";

export class CreditRequestUtils {
    static getPersonalityDescription(code: string) {
        let map = new Map<string, string>();
        map.set(Personality.PERSON, "Natural");
        map.set(Personality.LEGAL_ENTITY, "Juridico");
        return map.get(code) || "";
    }

    static getIdCause(clientStatus: string) {
        switch (clientStatus) {
            case "POT":
                return "0001";
            case "ACT":
                return "0003";
            case "INA":
                return "0004";
            default:
                return "0002";
        }
    }

    static getAge(birthDate: Date) {
        var timeDiff = Math.abs(Date.now() - birthDate.getTime());
        return Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25);
    }

    static getSex(sex: string) {
        switch (sex) {
            case "M":
                return "MASCULINO";
            case "F":
                return "FEMENINO";
            case "I":
                return "INDEFINIDO";
            default:
                return sex;
        }
    }

    static getIncomeType(code: string) {
        return incomeTypes.find(f => f.code == code) || { code: "", customerType: "", description: "" };
    }
}